import { FileDownloadOutlined } from '@mui/icons-material';
import { IconButton, Tooltip as MuiTooltip } from '@mui/material';
import React, { useCallback, useMemo } from 'react';

import { getLogsExportText } from 'new/elements/Button/logCopyText';
import { Log } from '../types';

interface LogDownloadIconButtonProps {
  logs: Log[];
  title: string;
  fileName: string;
}

const downloadIconRef = <FileDownloadOutlined fontSize="large" />;

export const LogDownloadIconButton = ({ logs, title, fileName }: LogDownloadIconButtonProps) => {
  const fileContent = useMemo(() => getLogsExportText(logs), [logs]);

  const hasNoLogsToDownload = logs.length === 0;

  const downloadLogs = useCallback(() => {
    const blob = new Blob([fileContent], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(url);
  }, [fileContent, fileName]);

  const iconButton = (
    <IconButton
      size="large"
      aria-label={title}
      onClick={downloadLogs}
      disabled={hasNoLogsToDownload}
    >
      {downloadIconRef}
    </IconButton>
  );

  return (
    <MuiTooltip title={title} arrow placement="top">
      {hasNoLogsToDownload ? <span>{iconButton}</span> : iconButton}
    </MuiTooltip>
  );
};
